/*
 * Copyright 2025 Mia srl
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Token Pricing Constants
 * 
 * Claude Haiku 4.5 Pricing (as of January 2026)
 * - Input: $0.80 per 1M tokens
 * - Output: $4.00 per 1M tokens
 * 
 * Future Enhancement: Track pricing history per day to handle rate changes
 */

export const TOKEN_PRICING = {
  input: 1.10,  // $0.80 per 1M input tokens
  output: 5.50, // $4.00 per 1M output tokens
  currency: 'USD',
  model: 'Claude Haiku 4.5',
  provider: 'Anthropic',
  effectiveDate: '2026-01-01', // Track when pricing became effective
};

/**
 * Pricing History Structure (for future implementation)
 * 
 * Example:
 * export const PRICING_HISTORY = [
 *   {
 *     effectiveDate: '2026-01-01',
 *     model: 'Claude Haiku 4.5',
 *     input: 0.80,
 *     output: 4.00,
 *   },
 *   // Add new entries when pricing changes
 * ];
 * 
 * Usage:
 * - Query by date to get correct pricing for historical token usage
 * - Display pricing trends over time
 * - Calculate accurate historical costs
 */
